import { useId, type ReactNode } from 'react';

export type EvimoListPanelProps = {
  children: ReactNode;
  className?: string;
  /** Optional card header (evimo-incidents_v2 `.card-h`). */
  title?: ReactNode;
  /** Trailing header actions (Refresh / Add, links, counts). */
  extra?: ReactNode;
};

/**
 * Card shell for list screens: toolbar ({@link FilterBar}) + {@link EvimoTable}.
 * Matches docs/design/evimo-incidents_v2.html (`.card` + `.list-tools` + `.tbl-wrap`).
 */
export function EvimoListPanel({
  children,
  className,
  title,
  extra,
}: EvimoListPanelProps) {
  const showHeader = title != null || extra != null;
  const titleId = useId();

  return (
    <section
      className={['evimo-list-panel', className].filter(Boolean).join(' ')}
      aria-labelledby={showHeader && title != null ? titleId : undefined}
    >
      {showHeader ? (
        <header className="evimo-list-panel__header">
          {title != null ? (
            <h2 className="evimo-list-panel__title" id={titleId}>
              {title}
            </h2>
          ) : null}
          {extra != null ? (
            <div className="evimo-list-panel__extra">{extra}</div>
          ) : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}
